export default __webpack_public_path__ + "static/media/discord.4c2ae84b.svg";